import { render } from "./flat2Page.vue?vue&type=template&id=e84e5ca2"
import script from "./flat2Page.vue?vue&type=script&lang=js"
export * from "./flat2Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__